import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyService } from './currency.service';
import { UserPreferencesService } from './user-preferences.service';

@Pipe({
  name: 'prefundCurrency',
  standalone: true,
})
export class PrefundCurrencyPipe implements PipeTransform {
  constructor(
    private userPreferencesService: UserPreferencesService,
    private currencyService: CurrencyService
  ) {}

  transform(value: number | undefined): string {
    value = value ?? 0;

    let formattedValue = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    if (formattedValue.endsWith('.00')) {
      formattedValue = formattedValue.slice(0, -3);
    }

    const currencyCode = this.userPreferencesService.preferences.currencyCode;
    let symbol = null;
    if (currencyCode) {
      const currency = this.currencyService.currencies.find(
        (c) => c.code === currencyCode
      );
      if (currency) {
        symbol = currency.symbol_native;
      }
    }

    return symbol ? `${formattedValue} ${symbol}` : formattedValue;
  }
}
